






































































































import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { SwSelect } from '@libs-uuif/shared/sw-select';
import Component from 'vue-class-component';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwForm, SwFormRow,  SwFormRowError } from '@libs-uuif/shared/sw-form';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { Prop } from 'vue-property-decorator';
import { required } from 'vuelidate/lib/validators';

const cssPrefix = 'edit-basic-info';
@Component({
  components: {
    SwSelect,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
    SwTextfield,
    SwForm,
    SwFormRow,
    SwFormRowError,
  },
  validations: {
    firstName: { required },
    lastName: { required },
    companyName: { required },
  },
})
export default class EditBasicInfo extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ required : true })
  editBasicInfoModal: boolean;

  @Prop({ required : true })
  basicInfoObj: any;

  @Prop()
  showFields: any;

  firstName: string = '';
  lastName: string = '';
  title: string = '';
  companyName: string = '';

  created() {
    console.warn(this.basicInfoObj);
    this.firstName = this.basicInfoObj.firstName || '';
    this.lastName = this.basicInfoObj.lastName || '';
    this.title = this.basicInfoObj.title || '';
    this.companyName = this.basicInfoObj.companyName || '';
  }

  checkInputValidation(): boolean {
    this.$v!.firstName!.$touch();
    this.$v!.companyName!.$touch();
    this.$v!.lastName!.$touch();
    if (!this.$v!.firstName!.$invalid && !this.$v!.lastName!.$invalid &&
        !this.$v!.companyName!.$invalid &&
        (this.firstName != null && this.firstName !== '') &&
        (this.lastName != null && this.lastName !== '') &&
        (this.companyName !== null && this.companyName !== '')) {
      return true;
    }
    return false;
  }

  checkInputValidationForCompany(): boolean {
    this.$v!.companyName!.$touch();
    if (!this.$v!.companyName!.$invalid &&
        (this.companyName !== null && this.companyName !== '')) {
      return true;
    }
    return false;
  }

  checkInputValidationForpersonal(): boolean {
    this.$v!.firstName!.$touch();
    this.$v!.lastName!.$touch();
    if (!this.$v!.firstName!.$invalid && !this.$v!.lastName!.$invalid &&
        (this.firstName != null && this.firstName !== '') &&
        (this.lastName != null && this.lastName !== '')) {
      return true;
    }
    return false;
  }

  submit() {
    if (this.showFields === 'all') {
      if (!this.checkInputValidation()) {
        return;
      }
      const req = {
        firstname : this.firstName,
        lastname : this.lastName,
        title : this.title,
        company : this.companyName,
      };
      this.$store.dispatch('SnbProfileStoreModule/updateBasicInfo', req)
      .then((resp) => {
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          this.closeDialog({ refresh: true });
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          this.$store.commit('stopLoading');
        }
      })
      .catch((err:any) => {
        console.error(err);
      });
    } else {
      if ((this.showFields === 'company' && !this.checkInputValidationForCompany()) ||
      (this.showFields === 'personal' && !this.checkInputValidationForpersonal())) {
        return;
      }
      let req: any = {};
      if (this.showFields === 'company') {
        req = {
          company : this.companyName,
          mode: 'ORGANIZATION',
        };
      } else {
        req = {
          firstname : this.firstName,
          lastname : this.lastName,
          title : this.title,
        };
      }
      this.$store.dispatch('SnbProfileStoreModule/updateBasicInfo', req)
      .then((resp) => {
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          this.closeDialog({ refresh: true });
          this.$store.commit('enqueueMessage', { infoType: 'success', infoMsg: resp.msgDesc });
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          this.$store.commit('stopLoading');
        }
        console.warn(resp);
      })
      .catch((err:any) => {
        console.error(err);
      });
    }
  }

  cancel() {
    this.closeDialog();
  }

  closeDialog(params:any = { refresh: false }) {
    this.$emit('closeBasicInfoDialog', params);
  }

}
